'use strict';

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const TimeSeries=require('pulsar-dashboard-core/dist-es6/utilities/timeSeries');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const PointPlotterDirective=require('../../../../dist-es6/client/directives/plotting/pointPlotterDirective');let

IncidentPlotterDirective=class IncidentPlotterDirective extends PointPlotterDirective{
get objectBindings(){
return['snapToPoints','verticalAxis','pointRadius',...super.objectBindings];
}

get controller(){
return IncidentPlotterController;
}};let


IncidentPlotterController=class IncidentPlotterController extends PointPlotterDirective.Controller{
static get $inject(){
return['$scope','$element','$compile'];
}

constructor($scope,$element,$compile){
super($scope,$element,$compile);

this.hitAreaWidth=this.pointRadius*2;
this._incidentIconHeight=this.pointRadius*4;
}

_getInterpolatedPointInfos(incidents){
return incidents.map((incident,index)=>{
const x=this._getXValueFrom(incident);
const interpolatedPoint=TimeSeries.getInterpolatedPointAtTime(this.snapToPoints,incident.time);
const y=this.verticalAxis.scale(interpolatedPoint.value)-this.plotArea.graphAreaBoundaries.top;

return{incident,index,x,y};
});
}

_getPointInfos(incidents){
if(_.exists(this.snapToPoints)){
return this._getInterpolatedPointInfos(incidents);
}

return incidents.map((incident,index)=>({
incident,
index,
x:this._getXValueFrom(incident),
y:this.plotArea.graphAreaDimensions.height/2}));

}

_getXValueFrom(incident){
return this.horizontalAxis.scale(incident.time.getTime());
}

_getLineInfos(){
if(this.snapToPoints){
return{};
}

return{
x1:pointInfo=>pointInfo.x,
x2:pointInfo=>pointInfo.x,
y1:({y})=>this.plotArea.graphAreaBoundaries.top,
y2:({y})=>this.plotArea.graphAreaBoundaries.bottom,
class:this.class};

}

_getHitAreaInfos(){
const halfPointHeight=this._incidentIconHeight/2;

const getYPos=({y})=>_.exists(this.snapToPoints)?
y-halfPointHeight:
this.plotArea.graphAreaBoundaries.top;

const getHeight=({y})=>_.exists(this.snapToPoints)?
this._incidentIconHeight:
this.plotArea.graphAreaDimensions.height;

return{
x:({x})=>x-this.pointRadius,
y:getYPos,
width:this.hitAreaWidth,
height:getHeight,
fill:'transparent',
"pulsar-tooltip":!0,
"pulsar-tooltip-directive":'pulsar-incident-tooltip',
"pulsar-tooltip-data":point=>`controller.points[${point.index}]`,
class:this.class};

}

_precompileStep(d3Selection){
d3Selection.selectAll('image').
data(this._getPointInfos(this.points)).
enter().
append('image').
attr({
"xlink:href":'/images/sce.svg',
width:this.pointRadius*2,
height:this.pointRadius*2,
x:({x})=>x-this.pointRadius,
y:({y})=>y-this.pointRadius}).

style('pointer-events','none');
}};


module.exports=IncidentPlotterDirective;
//# sourceMappingURL=incidentPlotterDirective.js.map
